<div class="modal-container p-3">
  <img width="60" src="/assets/img/warning.png" />
  <h2 class="mt-3">
    {{ "authentication.networkWarning.suspiciousActivity" | translate }}
  </h2>
  <div class="mt-3">
    {{ "authentication.networkWarning.insecureNetwork" | translate }}
  </div>
  <button class="btn btn-verify mt-3 w-100" (click)="okayClicked()">
    {{ "common.amplify.okay" | translate }}
  </button>
  <div class="mt-2 support-text">
    {{ "authentication.networkWarning.supportTxt" | translate }}
  </div>
</div>
